/**
 * Browser-side errors that say nothing about our code, so they are not worth a Sentry event.
 *
 * Used by the customer and staff apps' Sentry `beforeSend`.
 */

/** Messages that mean a stale hashed chunk: recovered by chunk-reload.js. */
const STALE_CHUNK = [
  'Importing a module script failed',
  'Failed to fetch dynamically imported module',
  'Unable to preload CSS for',
  'is not a valid JavaScript MIME type',
  "Couldn't resolve component",
]

/**
 * Script injected into the page by a browser extension, anti-fingerprinting tool or in-app browser rejects a
 * promise with a bare string. It is not an Error, has no stack, and never comes from our bundle, e.g.
 * "Object Not Found Matching Id:11, MethodName:update, ParamCount:4" (JB-BOOKINGS-B).
 */
const INJECTED_SCRIPT = [/Object Not Found Matching Id:\s*\d+,\s*MethodName:\s*\w+,\s*ParamCount:\s*\d+/i]

export function isIgnorableBrowserError(message: string): boolean {
  return STALE_CHUNK.some((fragment) => message.includes(fragment)) || INJECTED_SCRIPT.some((re) => re.test(message))
}

/** Same message the apps' `beforeSend` has always matched: the thrown value plus the first exception's value. */
export function sentryEventMessage(
  event: { exception?: { values?: Array<{ value?: string }> } },
  originalException: unknown,
): string {
  return [
    originalException instanceof Error ? originalException.message : String(originalException ?? ''),
    event.exception?.values?.[0]?.value ?? '',
  ].join(' ')
}
